import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import PropTypes from 'prop-types';
import React from 'react';
import ExternalResourceLink from '../../core/ExternalResourceLink';
import withGS from '../../core/withGShoc';
import { globalStyles as styles } from '../../core/style/gstheme';
import { computeLabelFromType, getComponents, isRTL } from '../../core/utils/utils';
import CommonIriDisplay from '../../application-core/CommonIriDisplay';

const loadOptions = {
  predicates: [
    "http://www.w3.org/2000/01/rdf-schema#label",
    "http://www.w3.org/2000/01/rdf-schema#isDefinedBy",
    "https://grafsync.graphifi.com/schema/gs/visibility",
    "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
    "http://www.w3.org/2002/07/owl#deprecated",
  ]
};

class ResourceDisplay extends React.Component {

  render() {

    const { data, classes, viewLang, defaultLang, graph, project, components } = this.props;

    // If somebody else has deleted it we will now hide it
    if (data.pendingDeletion) return null;

    let label = "No label available";
    const displayLang = viewLang && data.label && data.label[viewLang] ?
      viewLang
      :
      data.label && data.label[defaultLang] ?
        defaultLang
        :
        "und";

    if (data.label && data.label[displayLang]) {
      label = Array.isArray(data.label[displayLang]) ?
        [...data.label[displayLang]].sort().join(" AND ")
        :
        data.label[displayLang];
    }

    let resourceType = computeLabelFromType(data.type);
    let dataComponents = getComponents(data, true, true);
    const rtl = isRTL(displayLang);

    return (
      <TableRow
        data-test={"resource-" + data.id}
        classes={{
          root: classes.stripedRow
        }}>
        <TableCell className={classes.tableCell} style={{ maxWidth: '300px', paddingTop: 12 }}>
          <Typography
            dir={rtl ? "rtl" : null}
            lang={displayLang}
            data-test={displayLang !== viewLang ? "no-lang-label" : "label"}
            className={classes.tableCellText}
            style={displayLang !== viewLang ?
              {
                color: '#CA4F0C',
                ...(rtl) && { textAlign: "right" }
              }
              :
              {
                ...(rtl) && { textAlign: "right" }
              }
            }>
            {label}
          </Typography>
        </TableCell>
        <TableCell className={classes.tableCell} style={{ maxWidth: '300px', paddingTop: 12 }}>
          <Typography className={classes.tableCellText}>
            {resourceType}
          </Typography>
        </TableCell>
        <TableCell className={classes.tableCell} style={{ maxWidth: '300px', paddingTop: 12 }}>
          <Typography className={classes.tableCellText}>
            {data.id}
          </Typography>
        </TableCell>
        <TableCell className={classes.tableCell} style={{ maxWidth: '300px', paddingTop: 12 }}>
          {dataComponents && dataComponents.map(isIn =>
            <div key={isIn}>
              {components.some(component => component.id === isIn) ?
                <CommonIriDisplay
                  key={isIn}
                  id={isIn}
                  handleNotAvailable={true}
                  viewLang={defaultLang}
                  defaultLang={defaultLang}
                  projectIRI={project}
                  isReadOnly={true}
                  graph={graph}
                  deeplink={true}
                  sourceType={data.type}
                  source={data.id} />
                :
                <ExternalResourceLink
                  key={isIn}
                  id={isIn}
                  graph={graph}
                  source={data.id}
                  isReadOnly={true} />
              }
            </div>
          )}
        </TableCell>
      </TableRow>
    );
  }
}

ResourceDisplay.propTypes = {
  classes: PropTypes.object,
  components: PropTypes.array.isRequired,
  data: PropTypes.object.isRequired,
  graph: PropTypes.string.isRequired,
  project: PropTypes.string.isRequired,
  defaultLang: PropTypes.string.isRequired,
  viewLang: PropTypes.string,
};

export default withStyles(styles)(withGS(ResourceDisplay, ["ALL"], null, loadOptions, true));